module.exports = __webpack_public_path__ + "img/imagenull.832d8628.png";